'use client';

import * as DS from '@aurorasolar/ds';
import Image, { type StaticImageData } from 'next/image';
import { type ReactNode } from 'react';

type Props = { bgImage: StaticImageData; children?: ReactNode };

export const BannerWide = ({ bgImage, children }: Props) => (
  <DS.DarkModeProvider>
    <DS.Flex alignItems="center" position="relative">
      <Image alt="" fill src={bgImage} style={{ filter: 'brightness(40%)', objectFit: 'cover' }} />
      <DS.Flex maxW={DS.BorealisTheme.screens.xl} px={{ _: 6, lg: 10 }} py={{ _: 9, lg: 192, md: 128 }} zIndex={1}>
        {children}
      </DS.Flex>
    </DS.Flex>
  </DS.DarkModeProvider>
);
